// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-example {
    margin: 10px;
}

.status-extended-example {
    margin: 10px 0px;
}

.status-example-column {
    margin: 10px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Docs/Components/Status/examples/Status.Example.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".status-example {\r\n    margin: 10px;\r\n}\r\n\r\n.status-extended-example {\r\n    margin: 10px 0px;\r\n}\r\n\r\n.status-example-column {\r\n    margin: 10px;\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
